const getTokenLogoURL = (address: string) =>
  `https://raw.githubusercontent.com/urrbn/arbor-assets/master/assets/logo/${address}.png`

export default getTokenLogoURL
